var HeroAdValidator = {};

HeroAdValidator.validateHotdot = function validateHotdot(adsJson) {
  if (!adsJson.hotdotposition) {
    throw new Error('hotdot position is not set.');
  }
};

HeroAdValidator.validateHeroImage = function validateHeroImage(adsJson) {
  return new Promise(function (resolve, reject) {
    if (adsJson.heroimageurl) {
      var image = new Image();

      image.onload = function () {
        resolve(image);
      };

      image.onerror = function () {
        reject(new Error("Can not load hero image from ".concat(adsJson.heroimageurl)));
      };

      image.src = adsJson.heroimageurl;
    } else {
      reject(new Error('heroimageurl is not set.'));
    }
  });
};

HeroAdValidator.validateTrackers = function validateTrackers(adsJson) {
  function isValidUrl(url) {
    var reg = /^((http[s]?):\/)\/([^:/\s]+)((\/\w+)*\/)([\w\-.]+[^#?\s]+)(.*)?(#[\w-]+)?$/;
    return reg.test(url.replace('<CHANNEL>', '').replace('<VIEWID>', '').replace('<RANDOM>', ''));
  }

  var reaTrackerUrl = 'https://sasinator.realestate.com.au/rea/';

  function isReaCountTracker(tracker) {
    return tracker.indexOf("".concat(reaTrackerUrl, "count")) === 0;
  }

  function isReaCTATracker(tracker) {
    return tracker.indexOf("".concat(reaTrackerUrl, "adclick")) === 0;
  }

  if (!adsJson.hotdotctaurl) {
    throw new Error('hotdotctaurl is not set.');
  }

  if (!isValidUrl(adsJson.hotdotctaurl) || !isReaCTATracker(adsJson.hotdotctaurl)) {
    throw new Error('hotdotctaurl has to be a valid rea tracker.');
  }

  if (!adsJson.hotdottrackers || !adsJson.impressiontrackers) {
    throw new Error('hotdottrackers or impressiontrackers is not set.');
  }

  adsJson.hotdottrackers.concat(adsJson.impressiontrackers).every(function (url) {
    if (url && !isValidUrl(url)) {
      var errorMessage = "the tracker url \"".concat(url, "\" is not in the right format.\nAn example of a properly formatted ULR is: \"https://sasinator.realestate.com.au/rea/adclick/FCID=XYZ\"\nPlease check for (Why can this fail?) in your inserted url.");
      throw new Error(errorMessage);
    }

    return true;
  });

  if (!adsJson.hotdottrackers.some(isReaCountTracker) || !adsJson.impressiontrackers.some(isReaCountTracker)) {
    throw new Error('hotdottrackers and impressiontrackers should contain at least one rea tracker.');
  }
};

HeroAdValidator.validateTemplate = function validateTemplate(adsJson) {
  if (!adsJson.templateurl) {
    throw new Error('Hero ad templateurl is not set.');
  }
};

HeroAdValidator.validate = function (json) {
  return new Promise(function (resolve) {
    HeroAdValidator.validateHotdot(json);
    HeroAdValidator.validateTrackers(json);
    HeroAdValidator.validateTemplate(json);
    resolve(json);
  }).then(function (jsonToValidate) {
    return HeroAdValidator.validateHeroImage(jsonToValidate);
  });
};

export default HeroAdValidator;
//# sourceMappingURL=HeroAdValidator.js.map